import React, { cloneElement, FC, Fragment, ReactElement } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import PropTypes from 'prop-types';

import Box from '../../layouts/Box';
import {
  ButtonsProps,
  OverlayContentProps,
  StyledOverlayContentProps,
} from './types';

const StyledOverlayContent = styled(Box)<StyledOverlayContentProps>(
  ({ scroll }) =>
    css({
      fontSize: 'body.2',
      lineHeight: 'body',
      overflowY: scroll ? 'scroll' : 'auto',
      height: '100%',
      WebkitOverflowScrolling: scroll ? 'touch' : 'auto', // smooth scroll on ios
    })
);

const OverlayContent: FC<OverlayContentProps> = ({
  children,
  buttons,
  onClose,
  scroll,
  ...rest
}) => (
  <Fragment>
    <StyledOverlayContent scroll={scroll} {...rest}>
      {children}
    </StyledOverlayContent>
    {buttons && cloneElement(buttons, { onClose })}
  </Fragment>
);

OverlayContent.propTypes = {
  buttons: PropTypes.shape({
    onClose: PropTypes.func,
    direction: PropTypes.string,
  }) as PropTypes.Validator<
    ReactElement<Partial<ButtonsProps>> | null | undefined
  >,
  onClose: PropTypes.func,
  scroll: PropTypes.bool,
};

export default OverlayContent;
